import { createSlice } from "@reduxjs/toolkit";
import { toast } from "@/lib/toast";

export interface CounterState {
  cart: [] | any;
}

const initialState: CounterState = {
  cart: [],
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addProductToCart: (state, action) => {
      const product: any = state.cart.find(
        (item: any) => item.id === action.payload.id
      );

      if (product) {
        toast.info("This product is already in his shopping cart");
      } else {
        state.cart.push({
          ...action.payload,
        });

        toast.success("product added successfully");
      }
    },
    deleteProduct: (state, action) => {
      state.cart = state.cart?.filter(
        (item: any) => item.id !== action.payload.id
      );
    },
  },
});

export const cartItem = (state: any) => state.cart.cart;
export const { addProductToCart, deleteProduct } = cartSlice.actions;

export default cartSlice.reducer;
